import { useSettings } from "@/context/SettingsContext";
import Seo from "@/components/site/Seo";

const PRIVACY = [
  ["Titolare del trattamento", "Osteria Aterrana, Via Madonna di Montevergine 34, borgo storico di Aterrana, Montoro (AV). P.IVA 03083930648. Telefono 331 10 91 971. Email osteriaaterrana@outlook.it."],
  ["Dati raccolti", "Per gestire una prenotazione raccogliamo solo nome, cognome, telefono, email, data, orario, numero di persone ed eventuali note che scegli di comunicarci (per esempio allergie)."],
  ["Finalità", "I dati servono esclusivamente a gestire la prenotazione e a contattarti in caso di variazioni. Il consenso facoltativo alle comunicazioni sull'osteria è separato e revocabile in qualsiasi momento."],
  ["Conservazione", "Conserviamo i dati per il tempo necessario alla gestione delle prenotazioni e degli obblighi collegati."],
  ["Diritti", "Puoi chiedere accesso, rettifica, cancellazione o limitazione dei tuoi dati scrivendoci o telefonando all'osteria."],
];

const COOKIE = [
  ["Cookie tecnici", "Il sito utilizza cookie e archiviazione locale necessari al funzionamento, per esempio per mantenere la sessione dell'area riservata e ricordare la scelta sui cookie."],
  ["Statistiche", "Solo dopo il tuo consenso esplicito attiviamo Google Analytics 4 per statistiche anonime e aggregate sulle pagine più visitate. Fino a quel momento nessun cookie di statistica viene installato (Google Consent Mode v2, analytics_storage negato per impostazione predefinita). Non trasmettiamo mai nome, email, telefono o codice della prenotazione. Puoi rifiutare scegliendo \"Solo necessari\" nel banner: il sito funziona esattamente allo stesso modo."],
  ["Marketing e profilazione", "Non sono attivi cookie pubblicitari o di profilazione di terze parti."],
  ["Consenso", "Se in futuro verranno attivati strumenti statistici o di marketing, verrà introdotto un sistema di gestione del consenso preventivo."],
  ["Contenuti esterni", "Alcune pagine incorporano una mappa fornita da OpenStreetMap: caricandola vengono trasmessi i dati tecnici necessari alla visualizzazione."],
];

export function LegalPage({ kind }) {
  const { settings } = useSettings();
  const privacy = kind === "privacy";
  const rows = privacy ? PRIVACY : COOKIE;
  return (
    <>
      <Seo
        title={`${privacy ? "Privacy Policy" : "Cookie Policy"} · Osteria Aterrana`}
        description={`${privacy ? "Informativa privacy" : "Informativa cookie"} del sito di Osteria Aterrana.`}
        path={privacy ? "/privacy" : "/cookie-policy"}
      />
      <div className="pt-36 md:pt-44 pb-28 bg-cream">
        <div className="container-ed max-w-3xl">
          <p className="eyebrow text-sage">Informativa</p>
          <h1 className="mt-5 font-serif text-4xl sm:text-5xl text-wood">
            {privacy ? "Privacy Policy" : "Cookie Policy"}
          </h1>
          <div className="mt-12 divide-y divide-wood/12 border-t border-wood/15">
            {rows.map(([t, d]) => (
              <section key={t} className="py-8">
                <h2 className="font-serif text-2xl text-wood">{t}</h2>
                <p className="mt-3 text-sm md:text-base text-foreground/70 leading-relaxed">{d}</p>
              </section>
            ))}
          </div>
          <p className="mt-10 text-xs text-foreground/50">
            Per qualsiasi richiesta: {settings.phone || "331 10 91 971"}.
          </p>
        </div>
      </div>
    </>
  );
}

export default LegalPage;
